import type { SectionCollapseStates } from '@/components/InvoiceReportDetailDrawer/hooks/useSectionCollapseStates';
import { SuspenseErrorBoundary } from '@/components/SuspenseErrorBoundary';
import { GetAdminInvoiceReportSummaryResponse } from '@/context/services/admin_invoice_reports/AdminInvoiceReportSummary.service';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { LeftContent } from './LeftContent';
import { RightContent } from './RightContent';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export type AdminInvoiceReportDetailProps = {
  reportId: string;
  summaryData?: GetAdminInvoiceReportSummaryResponse;
  isLoading?: boolean;
  sectionStates?: SectionCollapseStates;
  onSectionToggle?: (sectionId: string, isOpen: boolean) => void;
};

const InnerDetail: FC<AdminInvoiceReportDetailProps> = ({
  reportId,
  summaryData,
  isLoading,
  sectionStates,
  onSectionToggle,
}) => {
  return (
    <div className={cx('detail')}>
      <LeftContent
        reportId={reportId}
        data={summaryData}
        isLoading={isLoading}
        sectionStates={sectionStates}
        onSectionToggle={onSectionToggle}
      />
      <RightContent reportId={reportId} />
    </div>
  );
};

export const AdminInvoiceReportDetail: FC<AdminInvoiceReportDetailProps> = memo(
  (props) => {
    return (
      <SuspenseErrorBoundary>
        <InnerDetail {...props} />
      </SuspenseErrorBoundary>
    );
  }
);

AdminInvoiceReportDetail.displayName = 'AdminInvoiceReportDetail';
